module.exports = __webpack_public_path__ + "static/media/teploLogo.de69db8d.png";